import React from 'react';
import { HeadingBlock, HeadingContent, SpinnerBox } from './css';

const Spinner = () => {
  return <>
          <HeadingBlock>
            <HeadingContent>Updating profile</HeadingContent>
          </HeadingBlock>
          <SpinnerBox>
            <svg viewBox="0 0 100 100" width="0" height="0">
              <circle
                stroke="#66cc00"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="89, 200"
                strokeDashoffset="0"
                cx="50"
                cy="50"
                r="20"
              ></circle>
            </svg>
          </SpinnerBox>
        </>;
};   

export default Spinner;